export default Object.freeze({
    // Non-recommended sort must match supported BE API sortBy enum values
    // https://api.ratehub.dev/credit-cards-service/api-docs/#/default/post_low_interest
    PURCHASE_INTEREST_RATE: 'purchase-interest',
    ANNUAL_FEE: 'annual-fee',

    RECOMMENDED: 'recommended',
});
